var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "newsevents-item" }, [
    _c(
      "a",
      {
        staticClass: "newsevents-item__link-wrap",
        class: { nopage: _vm.newsEventItem.noPage },
        attrs: { href: _vm.newsEventItem.url },
      },
      [
        _c(
          "div",
          { staticClass: "newsevents-item__inner" },
          [
            _vm.newsEventItem.imageHtml
              ? _c("ResponsiveImage", {
                  attrs: {
                    imageModel: _vm.newsEventItem.imageHtml,
                    wrapClass: "newsevents-item__image",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "newsevents-item__text" }, [
              _c("div", { staticClass: "newsevents-item__info-text" }, [
                _c("div", { staticClass: "newsevents-item__type" }, [
                  _vm._v(_vm._s(_vm.newsEventItem.typeName)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "newsevents-item__date" }, [
                  _vm._v(_vm._s(_vm.newsEventItem.listDate)),
                ]),
                _vm._v(" "),
                _vm.newsEventItem.publisher
                  ? _c("div", { staticClass: "newsevents-item__publisher" }, [
                      _vm._v(_vm._s(_vm.newsEventItem.publisher)),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "newsevents-item__text-row" }, [
                _c("h3", { staticClass: "newsevents-item__headline" }, [
                  _vm._v(_vm._s(_vm.newsEventItem.listHeadline)),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }